import { render } from "./AccountDetails.vue?vue&type=template&id=9bcd87d2&scoped=true"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"

import "./AccountDetails.vue?vue&type=style&index=0&id=9bcd87d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bcd87d2"]])

export default __exports__